const _ = require('lib/underscore')
const Marionette = require('lib/marionette')
const Enter = require('lib/enter')
const ButtonModel = require('./button_model')
const Template = require('./button.html')

const log = require('log').create('button') // eslint-disable-line


const ButtonView = Marionette.View.extend({

    displayName: 'ButtonView',

    template: Template,

    tagName() {
        return this.model.get('tagName')
    },

    className() {
        const classes = []
        if (this.model.get('button')) classes.push('button')
        if (this.model.get('loading')) classes.push('loading disabled')
        if (this.model.get('disabled')) classes.push('disabled')
        classes.push(this.model.get('size'))
        classes.push(this.model.get('color'))
        classes.push(this.model.get('className'))
        return _.unique(classes).join(' ').replace(/ {2,}/, ' ').trim()
    },

    attributes() {
        const attributes = {
            disabled: false,
        }
        if (this.model.get('loading')) attributes.disabled = true
        if (this.model.get('disabled')) attributes.disabled = true

        // ensure that <button> has a type attribute
        if (this.tagName() === 'button') {
            attributes.type = this.model.get('type')
        }

        return attributes
    },

    initialize() {
        _.bindAll(this, 'onClick')

        if (!(this.model instanceof ButtonModel)) throw new Error('Button.View requires a Button.Model')

        this.listenTo(this.model, 'change:size change:color change:loading change:disabled', this.setClassName)
        this.listenTo(this.model, 'change:loading change:disabled', this.setAttributes)
        this.listenTo(this.model, 'change:text', this.render)
        this.listenTo(this.model, 'change:loading_text', this.render)

        if (this.model.get('default')) {
            Enter.listen(this.cid, this.onClick)
        }
    },

    setClassName() {
        const className = _.result(this, 'className')
        this.$el.attr('class', className)
    },

    setAttributes() {
        const attributes = _.result(this, 'attributes')
        this.$el.attr(attributes)
    },

    events: {
        'click': 'onClick',
    },

    onClick() {
        // ignore clicks on disabled buttons
        if (this.model.get('disabled')) return

        // check to see if the model has an onClick handler
        const handler = this.model.get('onClick')
        if (_.isFunction(handler)) {
            handler.call(this)
        }

        // trigger default click event
        this.trigger('click', this)

        // check to see if the model has a custom trigger event
        const trigger = this.model.get('trigger')
        if (trigger) this.trigger(trigger, this)
    },

    onBeforeDestroy() {
        Enter.unlisten(this.cid)
    },

})

module.exports = ButtonView
